import { bool, node, oneOfType, string } from 'prop-types'

import BorderedText from 'views/components/atoms/BorderedText'

const SearchProductLabel = ({ label, firstFound, ...rest }) => (
  <BorderedText
    {...rest}
    smaller
    skewed={firstFound}
    skewedRight={!firstFound}
    notexttransform
  >
    {label}
  </BorderedText>
)

SearchProductLabel.propTypes = {
  ...BorderedText.propTypes,
  label: oneOfType([node, string]).isRequired,
  children: node,
  firstFound: bool,
}

SearchProductLabel.defaultProps = {
  ...BorderedText.defaultProps,
  firstFound: false,
  label: null,
  children: null,
}

export default SearchProductLabel
